function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoNFT = /*#__PURE__*/function () {
  function SaitoNFT(app, mod) {
    var tx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, SaitoNFT);
    this.app = app;
    this.mod = mod;

    //
    // nft details from app.options.wallet
    //
    this.id = data === null || data === void 0 ? void 0 : data.id;
    if (data !== null && data !== void 0 && data.nft_id) {
      this.id = data === null || data === void 0 ? void 0 : data.nft_id;
    }
    this.slip1 = data === null || data === void 0 ? void 0 : data.slip1;
    this.slip2 = data === null || data === void 0 ? void 0 : data.slip2;
    this.slip3 = data === null || data === void 0 ? void 0 : data.slip3;

    //
    // Information encoded in the slips
    //
    this.uuid = null;
    this.creator = '';
    this.amount = BigInt(0); // How many nfts of this id of this slip
    this.deposit = BigInt(0); // nolans
    this.nft_type = '';
    this.expires_at = (data === null || data === void 0 ? void 0 : data.expires_at) != null ? data.expires_at : null;

    //
    // and/or general meta data
    //
    this.metadata = data;
    this.title = (data === null || data === void 0 ? void 0 : data.title) || '';
    this.description = (data === null || data === void 0 ? void 0 : data.description) || '';

    //
    // tx details
    //
    this.tx = tx;

    // Prioritize the tx_sig from the wallet_nft_list rather than the provided tx...
    this.tx_sig = (data === null || data === void 0 ? void 0 : data.nfttx_sig) || (data === null || data === void 0 ? void 0 : data.tx_sig) || tx.signature || '';

    //
    // NFT content
    //
    this.image = '';
    this.text = '';
    this.json = '';
    this.js = '';
    this.css = '';

    //
    // UI helpers
    //
    this.tx_fetched = false;
    this.load_failed = false;
    if (tx != null) {
      // Analyze TX for slips and extra information
      this.buildNFTData(tx);
    } else {
      // Assuming we had slips in data from our wallet, just extract them
      this.parseSlips();
    }
  }

  /**
   * Let modules respond to `saito-nft-transfer` mutate the outbound tx before sign/propagate.
   * @param {*} newtx unsigned transaction
   * @param {string} receiver recipient public key
   * @param {object} [data={}] optional transfer intent (e.g. { delegated: true })
   * @returns {Promise<*>} updated tx, or null if a handler blocked the send (after salert)
   */
  return _createClass(SaitoNFT, [{
    key: "modifyBeforeSend",
    value: function () {
      var _modifyBeforeSend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(newtx, receiver) {
        var data,
          nft_type,
          handlers,
          _iterator,
          _step,
          modobj,
          _args = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              data = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              nft_type = this.nft_type || (typeof this.returnType === 'function' ? this.returnType() : null);
              handlers = this.app.modules.getRespondTos('saito-nft-transfer', this);
              _iterator = _createForOfIteratorHelper(handlers);
              _context.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context.n = 8;
                break;
              }
              modobj = _step.value;
              if (!(!(modobj !== null && modobj !== void 0 && modobj["class"]) || !modobj["class"].includes(nft_type) || !nft_type)) {
                _context.n = 3;
                break;
              }
              return _context.a(3, 7);
            case 3:
              if (!(typeof modobj.onTransfer === 'function')) {
                _context.n = 7;
                break;
              }
              _context.p = 4;
              _context.n = 5;
              return modobj.onTransfer(this, newtx, receiver, data);
            case 5:
              newtx = _context.v;
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error('onTransfer() failed in module...', _t);
              salert("NFT transfer blocked by module...");
              return _context.a(2, null);
            case 7:
              _context.n = 2;
              break;
            case 8:
              _context.n = 10;
              break;
            case 9:
              _context.p = 9;
              _t2 = _context.v;
              _iterator.e(_t2);
            case 10:
              _context.p = 10;
              _iterator.f();
              return _context.f(10);
            case 11:
              return _context.a(2, newtx);
          }
        }, _callee, this, [[4, 6], [1, 9, 10, 11]]);
      }));
      function modifyBeforeSend(_x, _x2) {
        return _modifyBeforeSend.apply(this, arguments);
      }
      return modifyBeforeSend;
    }()
  }, {
    key: "fetchTransaction",
    value: function () {
      var _fetchTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this = this;
        var callback,
          localhost_only,
          my_callback,
          search_cond,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              callback = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;
              localhost_only = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
              my_callback = function my_callback() {
                _this.load_failed = false;
                if (callback) {
                  callback();
                }
              };
              if (this.id) {
                _context4.n = 1;
                break;
              }
              console.error('0.5 Unable to fetch NFT transaction (no nft id found)');
              my_callback();
              return _context4.a(2);
            case 1:
              this.tx_fetched = true;

              // If we already have the transaction AND the image/data, we're done
              if (!(this.tx && (this.image || this.text || this.js || this.css || this.json))) {
                _context4.n = 2;
                break;
              }
              console.debug('NFT already has all data');
              my_callback();
              return _context4.a(2);
            case 2:
              if (!(this.tx != null)) {
                _context4.n = 3;
                break;
              }
              console.debug('Building nft data from transaction');
              this.buildNFTData(this.tx);
              my_callback();
              return _context4.a(2);
            case 3:
              search_cond = this.tx_sig ? {
                sig: this.tx_sig
              } : {
                field4: this.id
              };
              console.debug('Fetching nft transaction from archive using: ', search_cond);
              _context4.n = 4;
              return this.app.storage.loadTransactions(search_cond, /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(txs) {
                  var remote_callback, peer;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        if (!((txs === null || txs === void 0 ? void 0 : txs.length) > 0)) {
                          _context3.n = 1;
                          break;
                        }
                        console.debug('local archive returned nft');
                        _this.buildNFTData(txs[0]);
                        my_callback();
                        _context3.n = 5;
                        break;
                      case 1:
                        if (!_this.tx_sig) {
                          _context3.n = 2;
                          break;
                        }
                        _context3.n = 2;
                        return _this.app.storage.loadTransactions({
                          field4: _this.id
                        }, /*#__PURE__*/function () {
                          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(txs) {
                            return _regenerator().w(function (_context2) {
                              while (1) switch (_context2.n) {
                                case 0:
                                  if ((txs === null || txs === void 0 ? void 0 : txs.length) > 0) {
                                    console.debug('local archive returned nft');
                                    _this.buildNFTData(txs[0]);
                                    my_callback();
                                  }
                                case 1:
                                  return _context2.a(2);
                              }
                            }, _callee2);
                          }));
                          return function (_x4) {
                            return _ref2.apply(this, arguments);
                          };
                        }());
                      case 2:
                        if (!localhost_only) {
                          _context3.n = 3;
                          break;
                        }
                        return _context3.a(2, null);
                      case 3:
                        remote_callback = function remote_callback() {};
                        console.debug('trying remote archive for nft');
                        //
                        // try remote host (ours IS **NOW**  INDEXING NFT TXS)
                        //
                        _context3.n = 4;
                        return _this.app.network.getPeers();
                      case 4:
                        peer = _context3.v;
                        _this.app.storage.loadTransactions(search_cond, function (txs) {
                          if ((txs === null || txs === void 0 ? void 0 : txs.length) > 0) {
                            console.debug('remote archive returned nft');
                            _this.buildNFTData(txs[0]);
                            _this.app.storage.saveTransaction(txs[0], {
                              field4: _this.id,
                              preserve: 1
                            }, 'localhost');
                            my_callback();
                          } else {
                            _this.load_failed = true;
                          }
                        }, peer !== null && peer !== void 0 && peer.length ? peer[0] : null);
                      case 5:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }(), 'localhost');
            case 4:
              return _context4.a(2, null);
          }
        }, _callee4, this);
      }));
      function fetchTransaction() {
        return _fetchTransaction.apply(this, arguments);
      }
      return fetchTransaction;
    }()
  }, {
    key: "buildNFTData",
    value: function buildNFTData(tx) {
      var _this$slip, _this$tx$to$, _this$tx, _this$slip2, _this$tx$to$2, _this$tx2, _this$slip3, _this$tx$to$3, _this$tx3;
      var this_self = this;
      if (!tx) {
        return;
      }

      //
      // tx is available we can extract slips & txmsg data (img/text)
      //
      this.extractNFTData(tx);

      // If we created the NFT with a specific TX_signature but not the TX
      // we only want to save the proper transaction
      if (!this.tx && this.tx_sig == tx.signature) {
        this.tx = tx;
      }

      //
      // ovveride only if value already not set
      //
      (_this$slip = this.slip1) !== null && _this$slip !== void 0 ? _this$slip : this.slip1 = this.extractSlipObject((_this$tx$to$ = (_this$tx = this.tx) === null || _this$tx === void 0 || (_this$tx = _this$tx.to) === null || _this$tx === void 0 ? void 0 : _this$tx[0]) !== null && _this$tx$to$ !== void 0 ? _this$tx$to$ : null);
      (_this$slip2 = this.slip2) !== null && _this$slip2 !== void 0 ? _this$slip2 : this.slip2 = this.extractSlipObject((_this$tx$to$2 = (_this$tx2 = this.tx) === null || _this$tx2 === void 0 ? void 0 : _this$tx2.to[1]) !== null && _this$tx$to$2 !== void 0 ? _this$tx$to$2 : null);
      (_this$slip3 = this.slip3) !== null && _this$slip3 !== void 0 ? _this$slip3 : this.slip3 = this.extractSlipObject((_this$tx$to$3 = (_this$tx3 = this.tx) === null || _this$tx3 === void 0 ? void 0 : _this$tx3.to[2]) !== null && _this$tx$to$3 !== void 0 ? _this$tx$to$3 : null);
      this.parseSlips();
    }
  }, {
    key: "resetNFT",
    value: function resetNFT(data) {
      this.slip1 = data === null || data === void 0 ? void 0 : data.slip1;
      this.slip2 = data === null || data === void 0 ? void 0 : data.slip2;
      this.slip3 = data === null || data === void 0 ? void 0 : data.slip3;
      this.tx_sig = (data === null || data === void 0 ? void 0 : data.tx_sig) || this.tx_sig;
      this.parseSlips();
    }
  }, {
    key: "parseSlips",
    value: function parseSlips() {
      var _this$slip4, _this$slip5, _this$slip6, _this$slip7;
      this.amount = BigInt(((_this$slip4 = this.slip1) === null || _this$slip4 === void 0 ? void 0 : _this$slip4.amount) || 0);
      this.creator = ((_this$slip5 = this.slip1) === null || _this$slip5 === void 0 ? void 0 : _this$slip5.public_key) || '';
      this.uuid = ((_this$slip6 = this.slip3) === null || _this$slip6 === void 0 ? void 0 : _this$slip6.public_key) || '';
      this.deposit = BigInt(((_this$slip7 = this.slip2) === null || _this$slip7 === void 0 ? void 0 : _this$slip7.amount) || 0);
      this.nft_type = this.returnType();
    }

    //
    // Extracts NFT image/text, tx_sig, txmsg data from a transaction
    //
  }, {
    key: "extractNFTData",
    value: function extractNFTData(tx) {
      var _this$txmsg$data, _this$txmsg, _this$txmsg2, _this$txmsg3;
      if (!tx) {
        return;
      }
      var processed = false;
      var has_image = false;
      var has_css = false;
      var has_js = false;
      var has_text = false;
      if (!this.id) {
        this.id = this.app.wallet.computeNFTIdFromTx(tx);
      }
      this.txmsg = tx.returnMessage();
      this.data = (_this$txmsg$data = (_this$txmsg = this.txmsg) === null || _this$txmsg === void 0 ? void 0 : _this$txmsg.data) !== null && _this$txmsg$data !== void 0 ? _this$txmsg$data : {};
      this.applyExpiresAtFromData(this.data);
      if (typeof this.data.image !== 'undefined') {
        this.image = this.data.image;
        has_image = true;
        processed = true;
      }
      if ((_this$txmsg2 = this.txmsg) !== null && _this$txmsg2 !== void 0 && _this$txmsg2.description && !this.description) {
        this.description = this.txmsg.description;
      }
      if ((_this$txmsg3 = this.txmsg) !== null && _this$txmsg3 !== void 0 && _this$txmsg3.title && !this.title) {
        this.title = this.txmsg.title;
      }
      if (typeof this.data.css !== 'undefined') {
        has_css = true;
        this.css = this.data.css;
        processed = true;
      }
      if (typeof this.data.js !== 'undefined') {
        has_js = true;
        this.js = this.data.js;
        processed = true;
      }
      if (typeof this.data.text !== 'undefined') {
        has_text = true;
        this.text = this.data.text;
        processed = true;
      }
      if (Object.keys(this.data).length > 1) {
        if (has_image) {
          if (Object.keys(this.data).length > 2) {
            this.json = JSON.stringify(this.data, null, 2);
          }
        } else {
          this.json = JSON.stringify(this.data, null, 2);
        }
      }
      if (typeof this.data !== 'undefined' && processed == false) {
        this.json = _typeof(this.data) === 'object' ? JSON.stringify(this.data, null, 2) : String(this.data);
        processed = true;
      }
    }
  }, {
    key: "applyExpiresAtFromData",
    value: function applyExpiresAtFromData(data) {
      if (!data || _typeof(data) !== 'object') {
        return;
      }
      if (data.expires_at != null && data.expires_at !== '') {
        this.expires_at = data.expires_at;
        return;
      }
      var path = Array.isArray(data.path) ? data.path : [];
      for (var i = 0; i < path.length; i++) {
        var hop = path[i] || {};
        var value_obj = null;
        try {
          value_obj = JSON.parse(Buffer.from(String(hop.value || ''), 'base64').toString('utf8'));
        } catch (err) {
          value_obj = null;
        }
        if (value_obj && value_obj.delegated === 0 && value_obj.expires_at != null) {
          this.expires_at = value_obj.expires_at;
          return;
        }
      }
    }
  }, {
    key: "remainingExpiresLabel",
    value: function remainingExpiresLabel() {
      if (this.expires_at == null || this.expires_at === '') {
        return null;
      }
      var ms = Number(this.expires_at) - Date.now();
      if (!Number.isFinite(ms) || ms < 0) {
        ms = 0;
      }
      var total = Math.floor(ms / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor(total % 3600 / 60);
      var s = total % 60;
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return "".concat(pad(h), ":").concat(pad(m), ":").concat(pad(s));
    }
  }, {
    key: "extractSlipObject",
    value: function extractSlipObject(slip) {
      if (slip == null) return {};
      var toStr = function toStr(v) {
        return typeof v === 'bigint' ? v.toString() : String(v);
      };
      var toNum = function toNum(v) {
        return typeof v === 'number' ? v : Number(v !== null && v !== void 0 ? v : 0);
      };
      return {
        amount: slip.amount,
        // Keep as BigInt
        block_id: toStr(slip.blockId),
        public_key: slip.publicKey,
        slip_index: toNum(slip.index),
        slip_type: toNum(slip.type),
        tx_ordinal: toStr(slip.txOrdinal),
        utxo_key: slip.utxoKey
      };
    }
  }, {
    key: "setDeposit",
    value: function () {
      var _setDeposit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(saitoAmount) {
        var saitoStr, nolan;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(saitoAmount == null)) {
                _context5.n = 1;
                break;
              }
              throw new Error('setPrice: amount is required');
            case 1:
              saitoStr = typeof saitoAmount === 'bigint' ? saitoAmount.toString() : String(saitoAmount).trim();
              if (!(!saitoStr || isNaN(Number(saitoStr)))) {
                _context5.n = 2;
                break;
              }
              throw new Error('setPrice: invalid amount');
            case 2:
              _context5.n = 3;
              return this.app.wallet.convertSaitoToNolan(saitoStr);
            case 3:
              nolan = _context5.v;
              if (!(nolan == null)) {
                _context5.n = 4;
                break;
              }
              throw new Error('setPrice: conversion failed');
            case 4:
              this.deposit = BigInt(nolan);
              return _context5.a(2, this);
          }
        }, _callee5, this);
      }));
      function setDeposit(_x5) {
        return _setDeposit.apply(this, arguments);
      }
      return setDeposit;
    }()
  }, {
    key: "getDeposit",
    value: function getDeposit() {
      return this.app.wallet.convertNolanToSaito(this.deposit);
    }

    //
    // count items for merge
    //
  }, {
    key: "getSlipCount",
    value: function getSlipCount() {
      var _this$app,
        _this2 = this;
      var arr = ((_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.options) === null || _this$app === void 0 || (_this$app = _this$app.wallet) === null || _this$app === void 0 ? void 0 : _this$app.nfts) || [];
      return arr.filter(function (n) {
        return (n === null || n === void 0 ? void 0 : n.id) === _this2.id;
      }).length;
    }
  }, {
    key: "getTotalAmount",
    value: function getTotalAmount() {
      var all_slips = this.returnAllSlips();
      var total_amount = 0;
      for (var z = 0; z < all_slips.length; z++) {
        total_amount += parseInt(all_slips[z].slip1.amount);
      }
      return total_amount;
    }
  }, {
    key: "returnAllSlips",
    value: function returnAllSlips() {
      var nft_list = this.app.options.wallet.nfts;
      var all_slips = [];
      if (this.slip2.public_key !== this.mod.publicKey) {
        return [this];
      }
      for (var z = 0; z < nft_list.length; z++) {
        var n = nft_list[z];
        if (n.id == this.id) {
          all_slips.push(n);
        }
      }
      return all_slips;
    }
  }, {
    key: "returnType",
    value: function returnType() {
      var _this$slip8;
      if (this.nft_type) {
        return this.nft_type;
      }
      if ((_this$slip8 = this.slip3) !== null && _this$slip8 !== void 0 && _this$slip8.utxo_key) {
        this.nft_type = this.app.wallet.extractNFTType(this.slip3.utxo_key);
        if (this.nft_type) {
          return this.nft_type;
        }
      }
      var properties = ['image', 'text', 'json', 'js', 'css'];
      for (var _i = 0, _properties = properties; _i < _properties.length; _i++) {
        var prop = _properties[_i];
        var value = this[prop];
        if (value && (typeof value !== 'string' || value.trim() !== '')) {
          this.nft_type = prop;
          return prop;
        }
      }
      return null;
    }
  }, {
    key: "returnCreator",
    value: function returnCreator() {
      var _this$slip9, _this$slip0;
      if (this.creator) {
        return this.creator;
      }

      // The creator is the public key on the NFT UTXO (slip1)
      if ((_this$slip9 = this.slip1) !== null && _this$slip9 !== void 0 && _this$slip9.publicKey) {
        return this.slip1.public_key;
      }

      // Fallback: attempt extraction from utxo_key if available
      if ((_this$slip0 = this.slip3) !== null && _this$slip0 !== void 0 && _this$slip0.utxo_key) {
        var _nft$slip;
        var nft = this.app.wallet.extractNFT(this.slip3.utxo_key);
        if (nft !== null && nft !== void 0 && (_nft$slip = nft.slip1) !== null && _nft$slip !== void 0 && _nft$slip.public_key) {
          return nft.slip1.public_key;
        }
      }
      return null;
    }
  }, {
    key: "returnImage",
    value: function returnImage() {
      return this.image || '';
    }
  }, {
    key: "returnModuleMediaDisplay",
    value: function returnModuleMediaDisplay() {
      var nft_type = this.nft_type || (typeof this.returnType === 'function' ? this.returnType() : null);
      var handlers = this.app.modules.getRespondTos('saito-nft-media', this);
      var _iterator2 = _createForOfIteratorHelper(handlers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var modobj = _step2.value;
          if (!(modobj !== null && modobj !== void 0 && modobj["class"]) || !modobj["class"].includes(nft_type) || !nft_type) {
            continue;
          }
          if (typeof modobj.returnMediaDisplay === 'function') {
            var display = modobj.returnMediaDisplay(this);
            if (display) {
              return display;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return null;
    }
  }, {
    key: "hasResolvableMedia",
    value: function hasResolvableMedia() {
      if (this.returnImage()) {
        return true;
      }
      if (this.returnModuleMediaDisplay()) {
        return true;
      }
      return !!(this.js || this.css || this.text || this.json);
    }
  }, {
    key: "isMediaLoading",
    value: function isMediaLoading() {
      return this.returnMediaDisplay().loading;
    }
  }, {
    key: "returnMediaDisplay",
    value: function returnMediaDisplay() {
      var _this3 = this;
      var esc = function esc(value) {
        return _this3.app.browser.escapeHTML(String(value !== null && value !== void 0 ? value : ''));
      };
      var mediaUrl = function mediaUrl(url) {
        return _this3.app.browser.isSafeMediaUrl(url) ? url : '';
      };
      var moduleDisplay = this.returnModuleMediaDisplay();
      if (moduleDisplay) {
        return {
          backgroundImage: mediaUrl(moduleDisplay.backgroundImage || ''),
          innerHtml: moduleDisplay.innerHtml || '',
          loading: false,
          failed: false
        };
      }
      if (this.image) {
        return {
          backgroundImage: mediaUrl(this.image),
          innerHtml: '',
          loading: false,
          failed: false
        };
      }
      if (this.js) {
        return {
          backgroundImage: '',
          innerHtml: "<div class=\"saito-nft-card-text\">".concat(esc(this.js), "</div>"),
          loading: false,
          failed: false
        };
      }
      if (this.css) {
        return {
          backgroundImage: '',
          innerHtml: "<div class=\"saito-nft-card-text\">".concat(esc(this.css), "</div>"),
          loading: false,
          failed: false
        };
      }
      if (this.text) {
        return {
          backgroundImage: '',
          innerHtml: "<div class=\"saito-nft-card-text\">".concat(esc(this.text), "</div>"),
          loading: false,
          failed: false
        };
      }
      if (this.json) {
        return {
          backgroundImage: '',
          innerHtml: "<div class=\"saito-nft-card-text\">".concat(esc(this.json), "</div>"),
          loading: false,
          failed: false
        };
      }
      if (this.load_failed) {
        return {
          backgroundImage: '',
          innerHtml: '<i class="fa-solid fa-heart-crack"></i>',
          loading: false,
          failed: true
        };
      }
      return {
        backgroundImage: '',
        innerHtml: '',
        loading: true,
        failed: false
      };
    }
  }]);
}();
module.exports = SaitoNFT;